module.exports = __webpack_public_path__ + "img/TFS_FantasySword.8d0e4ab6.png";